import { createMuiTheme } from '@material-ui/core';
import overrides from './overrides';
import palette from './palette';
import typography from './typography';

import './global.scss';

// @ts-ignore
export default createMuiTheme({
  // @ts-ignore
  overrides,
  palette,
  // @ts-ignore
  typography,
});
